'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import * as appSelectors from 'DesignData/selectors/app';
import { getFile } from 'DesignData/selectors/finder';
import { FilePropTypes } from 'DesignData/propTypes/finder';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';

class StatusBarFilePath extends Component {
  render() {
    const {
      fileName,
      folderPath
    } = this.props;
    const filePath = folderPath ? `${folderPath}/${fileName}` : fileName;
    return /*#__PURE__*/_jsx(StatusBarSection, {
      label: filePath
    });
  }

}

StatusBarFilePath.propTypes = {
  folderPath: FilePropTypes.folderPath,
  fileName: FilePropTypes.fileName
};

const mapStateToProps = state => {
  const assetId = appSelectors.getActiveAssetId(state);
  const file = getFile(state, {
    fileId: assetId
  });
  return {
    folderPath: file ? file.folderPath : '',
    fileName: file ? file.name : ''
  };
};

export default connect(mapStateToProps, null)(StatusBarFilePath);